module.exports = __webpack_public_path__ + "static/media/redoblack.df3c4a92.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/logos/redoblack.png
// module id = 105
// module chunks = 0